import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Breadcrumb from '../../Globle/Breadecrumb'
import Affilate from '../MainAffilate/Affilate'
import Extra from '../MainAffilate/Extra'
import WhoWeAre from '../MainAffilate/WhoWeAre'
import Success from '../MainAffilate/Success'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadcrumb title='Affilate' />
            <Affilate />
            <Extra />
            <WhoWeAre />
            <Success />
            <Footer1 />
        </>
    )
}

export default Main
